"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAxiosAuthRequestInterceptor = void 0;
function createAxiosAuthRequestInterceptor(tokenService) {
    return async (config) => {
        const token = await tokenService.getAccessToken();
        config.headers.authorization = `Bearer ${token}`;
        return config;
    };
}
exports.createAxiosAuthRequestInterceptor = createAxiosAuthRequestInterceptor;
